import { createStructuredSelector } from 'reselect';
import {
  searchConfigSelector,
  searchResultConfigSelector,
  propertySelector,
  propertyListSelector,
  queryStringSelector,
  officeSelector,
  clientConfigSelector,
  importStatusSelector
} from '../../selectors/global';

export default createStructuredSelector({
  property: propertySelector,
  propertyList: propertyListSelector,
  queryString: queryStringSelector,
  searchConfig: searchConfigSelector,
  clientConfig: clientConfigSelector,
  searchResultConfig: searchResultConfigSelector,
  office: officeSelector,
  importStatus: importStatusSelector
});
